import { get } from "@devforce/trailhead-client-env";
export class Logger {
    constructor(opts = {}) {
        this.defaultOptions = {
            prefix: "[@devforce/trailhead-client-logger]: ",
        };
        this.options = this.defaultOptions;
        this.options = {
            ...this.defaultOptions,
            ...opts,
        };
    }
    info(msg, ...args) {
        // Don't log info in production environments
        if (get("DEBUG")) {
            console.info(`${this.options.prefix}${msg}`.trim(), ...args);
        }
    }
    warn(msg, ...args) {
        // Don't log warnings in production environments
        if (get("DEBUG")) {
            console.warn(`${this.options.prefix}${msg}`.trim(), ...args);
        }
    }
    error(msg, ...args) {
        var _a;
        console.error(`${this.options.prefix}${msg}`.trim(), ...args);
        /* eslint-disable */
        try {
            // @ts-ignore
            const error = msg instanceof Error ? msg : new Error(msg);
            // @ts-ignore
            (_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.noticeError(error);
        }
        catch (error) { }
        /* eslint-enable */
    }
}
export const logger = new Logger();
/**
 * Tests if the user's browser is officially supported
 */
export function isSupportedBrowser(userAgent = navigator.userAgent) {
    return /((CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS)[ +]+(15[_.]2|15[_.]([3-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})[_.]\d+)(?:[_.]\d+)?)|(Edge\/(98(?:\.0)?|98(?:\.([1-9]|\d{2,}))?|(99|\d{3,})(?:\.\d+)?))|((Chromium|Chrome)\/(98\.0|98\.([1-9]|\d{2,})|(99|\d{3,})\.\d+)(?:\.\d+)?)|(Version\/(15\.2|15\.([3-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})\.\d+)(?:\.\d+)? Safari\/)|(Firefox\/(97\.0|97\.([1-9]|\d{2,})|(9[8-9]|\d{3,})\.\d+)\.\d+)|(Firefox\/(97\.0|97\.([1-9]|\d{2,})|(9[8-9]|\d{3,})\.\d+)(pre|[ab]\d+[a-z]*)?)/.test(userAgent);
}
